module.exports = __webpack_public_path__ + "img/29.6aa939a4.png";